import React from 'react'

const PageNotFound = () => {
  return <>404</>
}

export default PageNotFound
